module.exports = __webpack_public_path__ + "static/media/virtuoso_logo.cf43ec06.png";